import React from "react";

const OPTIONS = [{ value: "ALL", label: "All" }, { value: "UP", label: "▲ Up" }, { value: "WAIT", label: "● Wait" }, { value: "DOWN", label: "▼ Down" }];

export default function MSIDirectionFilter({ value, onChange }) {
  return <div className="msi-direction-filters" role="group" aria-label="Filter structures by direction">
    {OPTIONS.map((option) => <button key={option.value} type="button" aria-pressed={value === option.value} onClick={() => onChange(option.value)}>{option.label}</button>)}
  </div>;
}

